// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"constraint"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M9 16.9997H6.19552C3.32112 16.9719 1 14.7441 1 12C1 9.25589 3.32112 7.02809 6.19552 7.00026L9 7M16 12H8M15 7L17.75 7.00001C20.6495 7.00001 23 9.23858 23 12C23 14.7614 20.6495 17 17.75 17L15 17","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ConstraintIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'constraint',
    ref,
    icon: element,
  },
));

ConstraintIcon.displayName = 'ConstraintIcon';

export default ConstraintIcon;
